export const matomoTracker = {
  init: function (selector) {
    selector = selector ?? '[data-matomo-category]';
    window.addEventListener('load', () => this.setup(selector));
  },

  setup: function (selector) {
    const buttons = document.querySelectorAll(selector);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const category = btn.getAttribute('data-matomo-category');
        const action = btn.getAttribute('data-matomo-action');
        const name = btn.getAttribute('data-matomo-name');

        if (window._paq) {
          window._paq.push(['trackEvent', category, action, name]);
        }
      });
    });
  }
};
